"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "social-login" };
const _hoisted_2 = { class: "flex items-center justify-center gap-x-6" };
const AppleLogin_vue_1 = __importDefault(require("@/components/SocialLogins/AppleLogin.vue"));
const GoogleLogin_vue_1 = __importDefault(require("@/components/SocialLogins/GoogleLogin.vue"));
const FacebookLogin_vue_1 = __importDefault(require("@/components/SocialLogins/FacebookLogin.vue"));
const store_1 = require("@/state/store");
const utils_1 = require("@/services/utils");
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SocialLogin',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((0, vue_2.unref)(store_1.store).isLandingPage ? 'h2' : 'h3'), { class: "line-on-side mb-4 text-center text-base leading-5 text-gray-80" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.store).isLogin ? (0, vue_2.unref)(main_1.$t)("login.social_headline") : (0, vue_2.unref)(main_1.$t)("registration.social_headline")), 1)
                    ]),
                    _: 1
                })),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (!(0, vue_2.unref)(utils_1.isInAppBrowser)())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AppleLogin_vue_1.default, { key: 0 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (!(0, vue_2.unref)(utils_1.isInAppBrowser)())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(GoogleLogin_vue_1.default, { key: 1 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(FacebookLogin_vue_1.default)
                ])
            ]));
        };
    }
});
